import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FaStethoscope, FaProcedures, FaHospital, FaUserMd, FaHeart, FaClinicMedical, FaCheckCircle, FaSearchPlus, FaTint, FaHeartBroken, FaDisease, FaBandAid, FaClipboardCheck, FaDna, FaVirus, FaCut, FaNotesMedical, FaHandHoldingMedical, FaFacebookF, FaLinkedinIn, FaTwitter, FaShieldAlt, FaArrowRight } from "react-icons/fa";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import WorkingProcess from "../Section/WorkingProcess";
import Spacing from "../Spacing";
import Post from "../Post";
import styled from "styled-components";
import FaqSectionStyle4 from "../FaqSection/FaqSectionStyle4";
import { Helmet } from "react-helmet";
import RecentPostWidget from "../Widget/RecentPostWidget";
import NewsletterStyle5 from "../Widget/NewsletterStyle5";

const recentPostData = [
  {
    title: `Advanced IUI Treatments at Pluro Jabalpur Fertility Centre`,
    author: "Dr. Archana Shrivastava",
    date: "August 10, 2023",
    href: "/IUI",
  },
  {
    title: `Advanced IVF Treatments`,
    author: "Dr. Archana Shrivastava",
    date: "August 10, 2023",
    href: "/IVF",
  },
  {
    title: `Advanced ICSI Treatments at Pluro Jabalpur Fertility Centre`,
    author: "Dr. Archana Shrivastava",
    date: "August 10, 2023",
    href: "/ICSI",
  },
  {
    title: `Advanced Male Infertility Treatments at Pluro Jabalpur Fertility Centre`,
    author: "Dr. Archana Shrivastava",
    date: "August 10, 2023",
    href: "/Tesa-Pesa",
  },
  {
    title: `Advanced Diagnostic and Surgical Techniques at Pluro Jabalpur Fertility Centre`,
    author: "Dr. Archana Shrivastava",
    date: "August 10, 2023",
    href: "/Laparoscopy",
  },
];

const relatedBlog = [
  {
    title:
      "The Importance of Mental Health: Understanding and Managing Anxiety Disorders",
    thumbUrl: "/images/blog/post_1.jpeg",
    date: "March 12",
    btnText: "Learn More",
    href: "/blog/blog-details",
  },
];

const faqData = [
  {
    title:
      " What are hysteroscopy and laparoscopy and how are they used in fertility treatments ?",
    content:
      "Hysteroscopy and laparoscopy are minimally invasive surgical procedures used to diagnose and treat conditions affecting fertility. Hysteroscopy involves inserting a thin, lighted tube (hysteroscope) through the cervix to examine the inside of the uterus, diagnosing and treating abnormalities such as polyps, fibroids, and adhesions. Laparoscopy involves inserting a thin, lighted tube (laparoscope) through a small incision in the abdomen to examine the pelvic organs, diagnosing and treating conditions like endometriosis, Fibroids, ovarian cysts, and tubal blockages.",
  },
  {
    title:
      "What conditions can be diagnosed or treated with hysteroscopy and laparoscopy ?",
    content:
      "Both procedures can address a variety of fertility-related conditions. Hysteroscopy can diagnose and treat uterine polyps, fibroids, uterine adhesions (Asherman’s syndrome), congenital uterine abnormalities, and abnormal uterine bleeding. Laparoscopy can diagnose and treat fibroids, endometriosis, ovarian cysts, pelvic adhesions, tubal blockages, ectopic pregnancy, and unexplained infertility.",
  },
  {
    title: "What is the recovery time for hysteroscopy and laparoscopy ?",
    content:
      "Recovery times for both procedures are relatively short but can vary. Hysteroscopy is generally performed as an outpatient procedure, with most patients returning to normal activities within a day or two, though mild cramping and spotting may occur for a few days post-procedure. Laparoscopy is usually performed as an outpatient procedure, sometimes requiring an overnight stay. Most patients can return to light activities within a week, with full recovery typically taking 1-2 weeks depending on the extent of the surgery. Some shoulder pain may occur due to the gas used to inflate the abdomen during the procedure.",
  },
  {
    title:
      "Are there any risks or complications associated with hysteroscopy and laparoscopy ?",
    content:
      "Both procedures are generally safe but carry some risks. Hysteroscopy risks include infection, uterine perforation (rare), bleeding, and adverse reaction to anesthesia. Laparoscopy fibroids risks include infection, bleeding, injury to surrounding organs (bladder, bowel, blood vessels), adverse reaction to anesthesia, and rare blood clots.",
  },
  {
    title: "How should I prepare for hysteroscopy and laparoscopy ?",
    content:
      "Proper preparation can help ensure a smooth procedure and recovery. For hysteroscopy, follow pre-procedure instructions regarding fasting and medication adjustments, arrange for someone to drive you home after the procedure, and inform your doctor of any allergies or medications you are taking. For laparoscopy, follow pre-procedure instructions regarding fasting and medication adjustments, arrange for someone to drive you home and assist you post-procedure, wear loose, comfortable clothing to the procedure, and inform your doctor of any medical conditions, allergies, or medications you are taking.",
  },
];

const workingProcessData = [
  {
    title: "Diagnostic Hysteroscopy",
    subTitle:
      "Insertion of a hysteroscope through the cervix into the uterus to examine the uterine cavity involves visual inspection of the endometrium and identification of any abnormalities.",
    iconUrl: "/images/home_2/departmentLap.png",
    number: "01",
  },
  {
    title: "Operative Hysteroscopy",
    subTitle:
      "In cases where abnormalities such as polyps or fibroids are detected, surgical instruments can be passed through the hysteroscope to remove or treat these lesions, offering a minimally invasive approach with a shorter recovery time compared to traditional surgery.",
    iconUrl: "/images/home_2/departmentLap2.png",
    number: "02",
  },
];

const PesaData = [
  {
    title: "Diagnostic Laparoscopy",
    subTitle:
      "Insertion of a laparoscope through a small incision near the navel allows visualization of the pelvic organs, enabling examination of the uterus, fallopian tubes, ovaries, and surrounding structures for abnormalities.",
    iconUrl: "/images/home_2/departmentLap.png",
    number: "01",
  },
  {
    title: "Operative Laparoscopy",
    subTitle:
      "Performance of surgical procedures such as ovarian cystectomy, treatment of endometriosis, removal of fibroids, or tubal reanastomosis is achieved through additional small incisions, using precise surgical instruments to minimize trauma and scarring.",
    iconUrl: "/images/home_2/department_icon7.png",
    number: "02",
  },
];

const colorOrange = "#FF8B13";
const colorPurple = "#9E58B6";

export default function Laparoscopy() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('cs_active');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.cs_reveal').forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Helmet>
        <title>Hysteroscopy & Laparoscopy – Minimally Invasive Fertility Procedures</title>
        <meta name="description" content="Diagnosis and treatment of uterine issues using safe, minimally invasive techniques like hysteroscopy and laparoscopy." />
        <meta name="keywords" content="hysteroscopy, laparoscopy, uterus treatment, fertility surgery" />
        <link rel="canonical" href="https://jabalpurivfcentre.com/Laparoscopy" />
      </Helmet>
      <Container className="cs_iui_new_wrap">
        {/* Banner Section */ }
        <BannerSectionStyle3
          bgUrl="/images/Laparoscopy.jpg"
          title="Welcome to <br /> Pluro Jabalpur<br /> Fertility Center"
          subTitle="Hysteroscopy and Laparoscopy Treatment"
        />

        {/* Post Meta & Share Section */ }
        <div className="container" style={ { marginTop: '60px' } }>
          <div className="cs_blog_details_info cs_reveal">
            <div className="cs_blog_details_info_left">
              <div className="cs_blog_details_date">
                March 12, 2024 | Dr. Archana Srivastava
              </div>
            </div>
            <div className="cs_social_links_wrap">
              <h2>Share:</h2>
              <div className="cs_mcp_doctor_socials mb-0 align-items-center">
                <Link to="https://www.facebook.com/PluroJabalpurFertilityAndIVFCentre/" className="cs_mcp_social_btn">
                  <FaFacebookF />
                </Link>
                <Link to="https://www.linkedin.com/in/jabalpur-fertility-centre-97504a227/" className="cs_mcp_social_btn">
                  <FaLinkedinIn />
                </Link>
                <Link to="https://x.com/jabalpurivf1" className="cs_mcp_social_btn">
                  <FaTwitter />
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Intro Section */ }
        <Section topMd={ 60 } topLg={ 40 } topXl={ 30 }>
          <div className="container">
            <div className="row align-items-center cs_reveal cs_premium_intro_row">
              <div className="col-lg-5">
                <div className="cs_intro_left">
                  <h1 className="cs_intro_title" style={ { fontSize: '32px' } }>
                    Advanced Diagnostic and Surgical Techniques at Pluro Jabalpur Fertility Centre
                  </h1>
                  <div className="cs_intro_divider" style={ { backgroundColor: colorOrange } }></div>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="cs_intro_right">
                  <p className="mb-0">
                    Hysteroscopy and laparoscopy are advanced minimally invasive procedures used for both diagnostic evaluation and surgical treatment of various gynecological conditions. At Pluro Jabalpur Fertility Centre, recognized as the Best Fertility Clinic in Jabalpur, we offer comprehensive hysteroscopy and laparoscopy services under the expert guidance of Dr. Archana Shrivastava, the Best IVF Doctor in Jabalpur. Our mission is to provide personalized, compassionate care and effective solutions for women’s health issues.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Section>

        {/* Hysteroscopy Reference Section */ }
        <OverlapSection className="cs_reveal" bgColor={ colorOrange } style={ { marginTop: '80px' } }>
          <div className="overlap-bg overlap-bg-left"></div>
          <div className="container relative z-10">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="overlap-content overlap-content-left">
                  <h3>What is Hysteroscopy?</h3>
                  <p>Hysteroscopy is a procedure that allows a doctor to examine the inside of the uterus (endometrial cavity) using a thin, lighted instrument called a hysteroscope. This procedure can be both diagnostic and therapeutic, enabling visualization and treatment of various uterine conditions.</p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="overlap-image-wrapper image-push-right">
                  <img src="/images/blog/hysteroscopy.jpg" alt="Hysteroscopy" />
                </div>
              </div>
            </div>
          </div>
        </OverlapSection>

        {/* Hysteroscopy Recommendations */ }
        <Section topMd={ 100 } topLg={ 80 } topXl={ 60 } className="cs_bento_section">
          <div className="container">
            <div className="text-center mb-5 cs_reveal">
              <h2 className="cs_fs_40 cs_medium" style={ { fontFamily: '"Playfair Display", serif', fontStyle: 'italic', color: '#1c2b38' } }>When is Hysteroscopy Recommended?</h2>
            </div>

            <div className="row justify-content-center cs_gap_y_40">
              <div className="col-lg-4 col-md-6">
                <div className="cs_bento_card theme-orange cs_reveal">
                  <div className="icon_container">
                    <FaTint />
                  </div>
                  <h3>Abnormal Uterine Bleeding</h3>
                  <p>Evaluation and treatment of abnormal menstrual bleeding.</p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="cs_bento_card theme-orange cs_reveal">
                  <div className="icon_container">
                    <FaHeartBroken />
                  </div>
                  <h3>Recurrent Miscarriages</h3>
                  <p>Investigation of uterine abnormalities that may contribute to recurrent miscarriages.</p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="cs_bento_card theme-orange cs_reveal">
                  <div className="icon_container">
                    <FaDisease />
                  </div>
                  <h3>Uterine Polyps or Fibroids</h3>
                  <p>Removal of polyps or fibroids that may affect fertility or cause abnormal bleeding.</p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="cs_bento_card theme-orange cs_reveal">
                  <div className="icon_container">
                    <FaBandAid />
                  </div>
                  <h3>Adhesions (Asherman’s Syndrome)</h3>
                  <p>Diagnosis and treatment of intrauterine adhesions that can result from previous surgeries or infections.</p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="cs_bento_card theme-orange cs_reveal">
                  <div className="icon_container">
                    <FaClipboardCheck />
                  </div>
                  <h3>Evaluation Prior to IVF</h3>
                  <p>Assessment of the uterine cavity before undergoing IVF treatment.</p>
                </div>
              </div>
            </div>
          </div>
        </Section>

        {/* Hysteroscopy Working Process */ }
        <Section topMd={ 80 } topLg={ 60 } topXl={ 40 }>
          <WorkingProcess
            sectionTitle="The Hysteroscopy Procedure"
            sectionTitleUp=""
            sectionTitleDown=""
            sectionSubTitle=""
            data={ workingProcessData }
          />
        </Section>

        {/* Laparoscopy Reference Section */ }
        <OverlapSection className="cs_reveal" bgColor={ colorPurple } style={ { marginTop: '80px' } }>
          <div className="overlap-bg overlap-bg-right"></div>
          <div className="container relative z-10">
            <div className="row align-items-center flex-row-reverse">
              <div className="col-lg-6">
                <div className="overlap-content overlap-content-right">
                  <h3>What is Laparoscopy ?</h3>
                  <p>Laparoscopy, also known as minimally invasive surgery or keyhole surgery, involves examining and treating pelvic organs through small incisions using a laparoscope (a thin, lighted instrument with a camera). This technique allows for precise diagnosis and treatment of various gynecological conditions.</p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="overlap-image-wrapper image-push-left">
                  <img src="/images/blog/Laparoscopic-surgery.png" alt="Laparoscopy" />
                </div>
              </div>
            </div>
          </div>
        </OverlapSection>

        {/* Laparoscopy Recommendations */ }
        <Section topMd={ 100 } topLg={ 80 } topXl={ 60 } className="cs_bento_section">
          <div className="container">
            <div className="text-center mb-5 cs_reveal">
              <h2 className="cs_fs_40 cs_medium">When is Laparoscopy Recommended?</h2>
            </div>

            <div className="row align-items-stretch cs_relative_z1">
              {/* Left Column: Image Card */ }
              <div className="col-lg-5 col-md-12 mb-4 mb-lg-0 cs_laparoscopy_sticky_col">
                <div className="cs_laparoscopy_img_card cs_reveal">
                  <img src="/images/blog/Laparoscopic-surgery.png" alt="Laparoscopic Surgery Diagram" className="w-100" />
                  <div className="cs_lic_badge">Clinical Care</div>
                </div>
              </div>

              {/* Right Column: List of Horizontal Cards */ }
              <div className="col-lg-7 col-md-12">
                <div className="cs_laparoscopy_list">
                  <div className="cs_laparoscopy_card_luxury theme_purple cs_reveal">
                    <div className="cs_lcl_icon">
                      <FaDna />
                    </div>
                    <div className="cs_lcl_content">
                      <h3>Endometriosis</h3>
                      <p>Diagnosis and surgical management of endometriosis, where tissue similar to the uterus lining grows outside it.</p>
                    </div>
                  </div>

                  <div className="cs_laparoscopy_card_luxury theme_orange cs_reveal">
                    <div className="cs_lcl_icon">
                      <FaVirus />
                    </div>
                    <div className="cs_lcl_content">
                      <h3>Ovarian Cysts</h3>
                      <p>Removal of benign ovarian cysts that may affect fertility or cause pelvic discomfort.</p>
                    </div>
                  </div>

                  <div className="cs_laparoscopy_card_luxury theme_orange cs_reveal">
                    <div className="cs_lcl_icon">
                      <FaCut />
                    </div>
                    <div className="cs_lcl_content">
                      <h3>Tubal Reversal Surgery</h3>
                      <p>Reversal of tubal ligation or surgical repair of blocked fallopian tubes to aid natural conception.</p>
                    </div>
                  </div>

                  <div className="cs_laparoscopy_card_luxury theme_purple cs_reveal">
                    <div className="cs_lcl_icon">
                      <FaSearchPlus />
                    </div>
                    <div className="cs_lcl_content">
                      <h3>Evaluation of Infertility</h3>
                      <p>Assessment of pelvic anatomy, detection of adhesions, pelvic inflammatory disease (PID), or ovarian disorders.</p>
                    </div>
                  </div>

                  <div className="cs_laparoscopy_card_luxury theme_purple cs_reveal">
                    <div className="cs_lcl_icon">
                      <FaNotesMedical />
                    </div>
                    <div className="cs_lcl_content">
                      <h3>Hysterectomy</h3>
                      <p>Surgical removal of the uterus (total laparoscopic hysterectomy) using minimally invasive keyhole incisions.</p>
                    </div>
                  </div>

                  <div className="cs_laparoscopy_card_luxury theme_orange cs_reveal">
                    <div className="cs_lcl_icon">
                      <FaHandHoldingMedical />
                    </div>
                    <div className="cs_lcl_content">
                      <h3>Myomectomy</h3>
                      <p>Removal of uterine fibroids while fully preserving the uterus for future pregnancies.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Section>

        {/* Laparoscopy Working Process */ }
        <Section topMd={ 80 } topLg={ 60 } topXl={ 40 }>
          <WorkingProcess
            sectionTitle="The Laparoscopy Procedure"
            sectionTitleUp=""
            sectionTitleDown=""
            sectionSubTitle=""
            data={ PesaData }
          />
        </Section>

        {/* Popular Articles and Newsletter Section */ }
        <Section topMd={ 100 } topLg={ 80 } topXl={ 60 }>
          <div className="container cs_reveal">
            <div className="row cs_gap_y_40 justify-content-center">
              <div className="col-lg-7">
                <div className="cs_sidebar_item" style={ { height: '100%' } }>
                  <RecentPostWidget title="Popular Articles" data={ recentPostData } />
                </div>
              </div>
              <div className="col-lg-5">
                <div className="cs_sidebar_item widget_categories" style={ { height: '100%' } }>
                  <NewsletterStyle5 title="Newsletter Sign Up Form" />
                </div>
              </div>
            </div>
          </div>
        </Section>

        {/* Benefits & Why Choose Us Section */ }
        <Section topMd={ 40 } topLg={ 30 } topXl={ 20 } className="cs_bento_section">
          <div className="container cs_reveal">
            <h2 className="text-center cs_fs_40 cs_medium mb-5" style={ { fontFamily: '"Playfair Display", serif', fontStyle: 'italic' } }>Benefits of Hysteroscopy and Laparoscopy</h2>
            <div className="row justify-content-center cs_gap_y_40 mb-5">
              <div className="col-lg-6 col-md-6">
                <div className="cs_laparoscopy_card_luxury theme_orange cs_reveal">
                  <div className="cs_lcl_icon">
                    <FaProcedures />
                  </div>
                  <div className="cs_lcl_content">
                    <h3>Minimally Invasive</h3>
                    <p>Small incisions lead to faster recovery, less pain, and reduced risk of infection compared to traditional open surgery.</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="cs_laparoscopy_card_luxury theme_purple cs_reveal">
                  <div className="cs_lcl_icon">
                    <FaSearchPlus />
                  </div>
                  <div className="cs_lcl_content">
                    <h3>Precise Diagnosis</h3>
                    <p>Detailed visualization of pelvic structures allows for accurate diagnosis of gynecological conditions.</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="cs_laparoscopy_card_luxury theme_purple cs_reveal">
                  <div className="cs_lcl_icon">
                    <FaStethoscope />
                  </div>
                  <div className="cs_lcl_content">
                    <h3>Effective Treatment</h3>
                    <p>Many conditions can be treated during the same procedure, minimizing the need for additional surgeries.</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="cs_laparoscopy_card_luxury theme_orange cs_reveal">
                  <div className="cs_lcl_icon">
                    <FaHospital />
                  </div>
                  <div className="cs_lcl_content">
                    <h3>Shorter Hospital Stay</h3>
                    <p>Most procedures are performed on an outpatient basis, allowing patients to return home the same day.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Why Choose Us Section */ }
            <div className="cs_premium_why_choose_split" style={ { marginTop: '80px', paddingTop: '60px', borderTop: '1px solid rgba(0,0,0,0.06)' } }>
              <div className="row align-items-center justify-content-center">
                {/* Left Column (roughly 50% / col-lg-5) */ }
                <div className="col-lg-5 col-md-12 pr-lg-4">
                  <div className="cs_pwc_left cs_reveal">
                    <span className="cs_pwc_badge">Why choose us</span>
                    <h2 className="cs_pwc_heading" style={ { fontSize: '30px', lineHeight: '1.35', marginBottom: '28px' } }>Why Choose Pluro Jabalpur Fertility Centre for Hysteroscopy and Laparoscopy?</h2>

                    <div className="cs_pwc_features">
                      <div className="cs_pwc_row cs_reveal">
                        <div className="cs_pwcr_icon theme_orange">
                          <FaUserMd />
                        </div>
                        <div className="cs_pwcr_text">
                          <h4>Expertise and Experience</h4>
                          <p>Led by Dr. Archana Shrivastava, our team has extensive experience in performing successful hysteroscopy and laparoscopy procedures.</p>
                        </div>
                      </div>

                      <div className="cs_pwc_row cs_reveal">
                        <div className="cs_pwcr_icon theme_purple">
                          <FaClinicMedical />
                        </div>
                        <div className="cs_pwcr_text">
                          <h4>State-of-the-Art Facility</h4>
                          <p>Equipped with advanced technology and facilities to ensure the highest standards of care and safety.</p>
                        </div>
                      </div>

                      <div className="cs_pwc_row cs_reveal">
                        <div className="cs_pwcr_icon theme_orange">
                          <FaStethoscope />
                        </div>
                        <div className="cs_pwcr_text">
                          <h4>Comprehensive Gynecological Services</h4>
                          <p>From initial consultation and diagnostic evaluation to minimally invasive surgery and post-operative care, we offer complete gynecological care.</p>
                        </div>
                      </div>

                      <div className="cs_pwc_row cs_reveal">
                        <div className="cs_pwcr_icon theme_purple">
                          <FaHeart />
                        </div>
                        <div className="cs_pwcr_text">
                          <h4>Patient-Centered Approach</h4>
                          <p>We prioritize your comfort and well-being, offering compassionate support throughout your fertility journey.</p>
                        </div>
                      </div>
                    </div>

                    <Link to="/contact" className="cs_pwc_btn">
                      Book a consultation <FaArrowRight />
                    </Link>
                  </div>
                </div>

                {/* Right Column (roughly 50% / col-lg-5) */ }
                <div className="col-lg-5 col-md-12 mt-5 mt-lg-0 d-flex justify-content-center">
                  <div className="cs_pwc_right cs_reveal">
                    <div className="cs_pwc_image_container">
                      <img src="/images/about/DrArchnaShrivastav.jpg" alt="Dr. Archana Shrivastava" className="cs_pwc_arch_img" />
                      <div className="cs_pwc_stat_card">
                        <div className="cs_pwcs_num">24+</div>
                        <div className="cs_pwcs_label">years of<br />experience</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Section>

        {/* FAQ Section */ }
        <Section topMd={ 40 } topLg={ 20 } topXl={ 0 }>
          <div className="cs_iui_faq_wrapper cs_reveal">
            <FaqSectionStyle4
            sectionTitle="Frequently Asked <br />Questions"
            data={ faqData }
            faqImgUrl="/images/home_4/faq_img.jpg"
            spiningImgUrl="/images/home_1/about_mini.svg"
          />
          </div>
        </Section>

        {/* Contact Us Section */ }
        <Section topMd={ 60 } topLg={ 40 } topXl={ 20 } bottomMd={ 100 } bottomLg={ 80 } bottomXl={ 60 }>
          <div className="container cs_reveal">
            <div className="cs_ivf_contact_banner" style={ { background: '#c77842', borderRadius: '20px', padding: '60px 50px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '30px' } }>
              <div className="cs_icc_content" style={ { flex: '1', minWidth: '300px' } }>
                <h2 style={ { color: '#fff', fontSize: '36px', marginBottom: '15px', fontWeight: '700' } }>Contact Us</h2>
                <p style={ { color: 'rgba(255,255,255,0.9)', fontSize: '18px', margin: '0', lineHeight: '1.6' } }>
                  If you require hysteroscopy or laparoscopy for diagnostic evaluation or treatment of gynecological conditions, contact Pluro Jabalpur Fertility Centre today. Our dedicated team is here to provide expert care and support to address your health needs effectively.
                </p>
              </div>
              <div className="cs_icc_action">
                <Link to="/contact" className="cs_btn" style={ { background: '#fff', color: '#c77842', padding: '15px 40px', borderRadius: '50px', fontWeight: '600', fontSize: '18px', display: 'inline-flex', alignItems: 'center', textDecoration: 'none', boxShadow: '0 10px 20px rgba(0,0,0,0.1)' } }>
                  <span>Get in Touch</span>
                </Link>
              </div>
            </div>
          </div>
        </Section>

        {/* Related Articles */ }
        <Section bottomMd={ 200 } bottomLg={ 150 } bottomXl={ 110 }>
          <div className="container cs_reveal">
            <h2 className="mb-0 cs_fs_40 cs_medium">Related Articles</h2>
            <Spacing md="57" />
            <div className="row cs_gap_y_40">
              { relatedBlog?.map((item, index) => (
                <div className="col-xl-12" key={ index }>
                  <Post { ...item } />
                </div>
              )) }
            </div>
          </div>
        </Section>
      </Container>
    </>
  );
}

const OverlapSection = styled.div`
  position: relative;
  overflow: hidden;
  padding: 100px 0;
  display: flex;
  align-items: center;
  min-height: 550px;

  .overlap-bg {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 60%;
    z-index: 1;
    background-color: ${props => props.bgColor};
  }

  .overlap-bg-left {
    left: 0;
    border-radius: 0 450px 450px 0;
  }

  .overlap-bg-right {
    right: 0;
    border-radius: 450px 0 0 450px;
  }

  .overlap-content {
    position: relative;
    z-index: 2;
    color: #fff;
    max-width: 500px;
    padding: 20px 0;

    h3 {
      color: #fff;
      font-size: 42px;
      font-weight: 700;
      margin-bottom: 24px;
      line-height: 1.2;
    }

    p {
      font-size: 18px;
      line-height: 1.8;
      color: rgba(255, 255, 255, 0.95);
      margin: 0;
    }
  }

  .overlap-content-left {
    margin-left: auto;
    margin-right: 0;
    padding-right: 40px;
  }

  .overlap-content-right {
    margin-right: auto;
    margin-left: 0;
    padding-left: 40px;
  }

  .overlap-image-wrapper {
    position: relative;
    z-index: 2;
    width: 450px;
    height: 450px;
    border-radius: 50%;
    overflow: hidden;
    background-color: #ffffff;
    border: 15px solid #fff;
    box-shadow: 0 30px 60px rgba(0,0,0,0.15);
    margin: 0 auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      padding: 10px;
    }
  }

  .image-push-right {
    transform: translateX(-40px);
  }

  .image-push-left {
    transform: translateX(40px);
  }

  @media (max-width: 991px) {
    padding: 60px 0;

    .overlap-bg {
      width: 100%;
      border-radius: 0 !important;
    }
    
    .overlap-content {
      max-width: 100%;
      padding: 0 20px;
      margin-bottom: 40px;
      text-align: center;
    }

    .overlap-image-wrapper {
      width: 320px;
      height: 320px;
      margin-top: 0;
      transform: translateX(0) !important;
      border-width: 8px;
    }
  }
`;

const Container = styled.div`
  .heading{
    font-size: 32px;
     @media (max-width: 991px) {
      font-size: 28px;
    }
  }
`;
